module.exports = __webpack_public_path__ + "static/img/15011465791.63faae1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/15011465791.png
// module id = EYXf
// module chunks = 0